import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MinusIcon, PlusIcon, ShoppingBagIcon, TagIcon, Trash2Icon, TruckIcon } from 'lucide-react';
import { useCart, FREE_SHIPPING_THRESHOLD } from '../contexts/CartContext';
import { formatPrice } from '../utils/format';
import { COLORS } from '../data/products';
export function Cart() {
  const {
    lines,
    lineProduct,
    updateQuantity,
    removeItem,
    subtotal,
    shipping,
    discount,
    total,
    freeShipping,
    couponCode,
    applyCoupon,
    clearCoupon,
    count
  } = useCart();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const handleCoupon = (e: React.FormEvent) => {
    e.preventDefault();
    if (applyCoupon(code)) {
      setError('');
      setCode('');
    } else {
      setError('Código inválido. Probá con ZADAR10.');
    }
  };
  return <div className="w-full bg-black" data-id="element-779" data-mp="1rruxy8j8igl">
      <div className="mx-auto w-full max-w-7xl px-5 py-12 lg:px-8 lg:py-16" data-id="element-780" data-mp="1stg4vj9ilc1">
        <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-pink-500" data-id="element-781" data-mp="29ij47en31e12">
          Paso 1 de 2
        </span>
        <h1 className="mt-3 font-display text-5xl uppercase leading-none text-white sm:text-6xl" data-id="element-782" data-mp="2ec44jdc5ek3f">
          Tu carrito
        </h1>
        <p className="mt-3 text-sm text-white/45" data-id="element-783" data-mp="24jydq6xmu8pt">
          {count} {count === 1 ? 'producto' : 'productos'} en el carrito
        </p>

        {lines.length === 0 ? <div className="mt-12 border border-dashed border-white/15 px-6 py-24 text-center" data-id="element-784" data-mp="2s7poh63iydoz">
            <ShoppingBagIcon className="mx-auto h-10 w-10 text-white/20" data-id="element-785" data-mp="2x6svux6z8w04" />
            <h2 className="mt-6 font-display text-3xl uppercase text-white" data-id="element-786" data-mp="2j8chql6sc37y">
              Tu carrito está vacío
            </h2>
            <p className="mx-auto mt-3 max-w-sm text-sm text-white/45" data-id="element-787" data-mp="2nck6gid8tj66">
              Sumá tus accesorios y empezá a entrenar sin dolor.
            </p>
            <Link to="/productos" className="mt-8 inline-block bg-pink-500 px-8 py-4 text-[11px] font-bold uppercase tracking-[0.18em] text-white transition-colors hover:bg-pink-600" data-id="element-788" data-mp="1bwlpztfqjuux">
              Ver productos
            </Link>
          </div> : <div className="mt-10 grid gap-8 lg:grid-cols-[1fr_380px]" data-id="element-789" data-mp="34rd020qyas45">
            {/* ITEMS */}
            <div className="space-y-4" data-id="element-790" data-mp="2zsa5594oq29w">
              {!freeShipping && <div className="flex items-start gap-3 border border-teal-500/30 bg-teal-500/10 px-4 py-3.5 text-sm text-teal-300" data-id="element-791" data-mp="2vs9emq4ba0mh">
                  <TruckIcon className="mt-0.5 h-4 w-4 shrink-0" data-id="element-792" data-mp="2qru4s8j8nb99" />
                  <p data-id="element-793" data-mp="2lt0oy9ghb85x">
                    Te faltan{' '}
                    <strong className="font-semibold" data-id="element-794" data-mp="2lvmuk3jt7dli">
                      {formatPrice(FREE_SHIPPING_THRESHOLD - subtotal)}
                    </strong>{' '}
                    para tener envío gratis.
                  </p>
                </div>}

              {lines.map(line => {
            const product = lineProduct(line);
            if (!product) return null;
            const color = COLORS.find(c => c.id === line.colorId);
            const unit = product.salePrice ?? product.price;
            return <article key={line.id} className="flex flex-col gap-5 border border-white/10 bg-ink-800 p-4 sm:flex-row sm:items-center" data-id="element-795" data-mp="wdg688dvrq2o">
                    <Link to={`/producto/${product.slug}`} className="h-24 w-24 shrink-0 overflow-hidden bg-black" data-id="element-796" data-mp="4mafujnyp6ql">
                      <img src={product.images[0]} alt={product.name} className="h-full w-full object-cover" data-id="element-797" data-mp="dldxrkbe7g3i" />
                    </Link>

                    <div className="min-w-0 flex-1" data-id="element-798" data-mp="1p0arv8mfovhq">
                      <h2 className="font-display text-xl uppercase leading-none tracking-wide text-white" data-id="element-799" data-mp="1tzx3xeqj05oy">
                        <Link to={`/producto/${product.slug}`} className="hover:text-pink-400" data-id="element-800" data-mp="32wlu54icks6t">
                          {product.name}
                        </Link>
                      </h2>
                      <p className="mt-2 flex items-center gap-2 text-xs text-white/45" data-id="element-801" data-mp="3bvfn8kwgz0fm">
                        <span className="h-3 w-3 rounded-full border border-white/20" style={{
                    backgroundColor: color?.hex
                  }} aria-hidden data-id="element-802" data-mp="370tl78ca2k87" />
                        {color?.name} · {product.categoryLabel}
                      </p>
                    </div>

                    <div className="flex items-center border border-white/15" data-id="element-803" data-mp="3qnr9likdligl">
                      <button type="button" onClick={() => updateQuantity(line.id, line.quantity - 1)} aria-label={`Quitar una unidad de ${product.name}`} className="p-2.5 text-white/60 transition-colors hover:bg-white/5 hover:text-white" data-id="element-804" data-mp="8gjxv854ltc7">
                        <MinusIcon className="h-3.5 w-3.5" data-id="element-805" data-mp="s0shgqirbdig" />
                      </button>
                      <span className="w-10 text-center text-sm font-semibold text-white" data-id="element-806" data-mp="d5chy5zeqpeo">
                        {line.quantity}
                      </span>
                      <button type="button" onClick={() => updateQuantity(line.id, line.quantity + 1)} aria-label={`Agregar una unidad de ${product.name}`} className="p-2.5 text-white/60 transition-colors hover:bg-white/5 hover:text-white" data-id="element-807" data-mp="4c9bwir3deu2">
                        <PlusIcon className="h-3.5 w-3.5" data-id="element-808" data-mp="3hjsukga7i7rg" />
                      </button>
                    </div>

                    <div className="text-right sm:w-32" data-id="element-809" data-mp="3ll5zmo5h66xb">
                      <p className="font-display text-2xl leading-none text-white" data-id="element-810" data-mp="3lkmmdkqrs6pm">
                        {formatPrice(unit * line.quantity)}
                      </p>
                      <p className="mt-1.5 text-xs text-white/35" data-id="element-811" data-mp="1naxer5slln9h">
                        {formatPrice(unit)} c/u
                      </p>
                    </div>

                    <button type="button" onClick={() => removeItem(line.id)} aria-label={`Eliminar ${product.name}`} className="self-start p-2 text-white/35 transition-colors hover:text-pink-500 sm:self-center" data-id="element-812" data-mp="1de2kiz3cy910">
                      <Trash2Icon className="h-4 w-4" data-id="element-813" data-mp="212c0hkdw42k8" />
                    </button>
                  </article>;
          })}

              <Link to="/productos" className="mt-2 inline-block border border-white px-6 py-3.5 text-[11px] font-bold uppercase tracking-[0.18em] text-white transition-colors hover:bg-white hover:text-black" data-id="element-814" data-mp="1x3urevawsi06">
                Seguir comprando
              </Link>
            </div>

            {/* SUMMARY */}
            <aside className="lg:sticky lg:top-28 lg:self-start" data-id="element-815" data-mp="31clf1rwgrb2j">
              <div className="border border-white/10 bg-ink-800 p-6" data-id="element-816" data-mp="36awr89a8dxnx">
                <h2 className="font-display text-2xl uppercase tracking-wide text-white" data-id="element-817" data-mp="368k0b6mhwcyq">
                  Resumen del pedido
                </h2>

                <dl className="mt-6 space-y-3.5 text-sm" data-id="element-818" data-mp="3g196pn36v0n7">
                  <div className="flex justify-between" data-id="element-819" data-mp="3g2snrfwo5fq1">
                    <dt className="text-white/50" data-id="element-820" data-mp="3ky80g4ixx5kv">Subtotal</dt>
                    <dd className="text-white" data-id="element-821" data-mp="3p1e5x9y8asqa">{formatPrice(subtotal)}</dd>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-822" data-mp="3tzz4l4xu14cm">
                    <dt className="text-white/50" data-id="element-823" data-mp="3ty4s8f0mmkk5">Envío</dt>
                    <dd data-id="element-824" data-mp="1uo6e7r5jux8v">
                      {shipping === 0 ? <span className="bg-teal-500 px-2 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-black" data-id="element-825" data-mp="1zlog4xl5gc7d">
                          Gratis
                        </span> : <span className="text-white" data-id="element-826" data-mp="1dk5sg0ofpss">{formatPrice(shipping)}</span>}
                    </dd>
                  </div>
                  {discount > 0 && <div className="flex items-center justify-between" data-id="element-827" data-mp="a4svl28o1wfn">
                      <dt className="flex items-center gap-2 text-white/50" data-id="element-828" data-mp="3ikw75j2wg599">
                        Descuento
                        <button type="button" onClick={clearCoupon} className="text-[10px] uppercase tracking-wider text-pink-400 hover:underline" data-id="element-829" data-mp="3ejkef4oqb3wu">
                          quitar
                        </button>
                      </dt>
                      <dd className="text-pink-400" data-id="element-830" data-mp="17r9qk0txfxy8">- {formatPrice(discount)}</dd>
                    </div>}
                </dl>

                <form onSubmit={handleCoupon} className="mt-6" data-id="element-831" data-mp="2krmpwdq13o3g">
                  <label htmlFor="coupon" className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/45" data-id="element-832" data-mp="2kq1vqp7mm764">
                    Código de descuento
                  </label>
                  <div className="mt-2 flex" data-id="element-833" data-mp="2gp9kxrj3vu7q">
                    <div className="relative flex-1" data-id="element-834" data-mp="2gqb64otu5x36">
                      <TagIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-white/30" data-id="element-835" data-mp="34eu7ekegx9lr" />
                      <input id="coupon" value={couponCode ?? code} disabled={!!couponCode} onChange={e => setCode(e.target.value)} placeholder="ZADAR10" className="w-full border border-white/10 bg-ink-900 py-3 pl-9 pr-3 text-sm uppercase text-white placeholder:text-white/30 focus:border-pink-500 focus:outline-none disabled:text-teal-400" data-id="element-836" data-mp="38fnuxco00me4" />
                    </div>
                    <button type="submit" disabled={!!couponCode} className="border border-l-0 border-white/10 px-4 text-[11px] font-bold uppercase tracking-[0.14em] text-white transition-colors hover:bg-white/5 disabled:text-white/30" data-id="element-837" data-mp="3h55tprocac88">
                      {couponCode ? 'Aplicado' : 'Aplicar'}
                    </button>
                  </div>
                  {error && <p className="mt-2 text-xs text-pink-400" data-id="element-838" data-mp="337hbyspkjl7e">{error}</p>}
                </form>

                <div className="mt-7 flex items-end justify-between border-t border-white/10 pt-6" data-id="element-839" data-mp="2oj2xtlmpcabj">
                  <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/50" data-id="element-840" data-mp="2tgmo5jwocdju">
                    Total
                  </span>
                  <span className="font-display text-4xl leading-none text-white" data-id="element-841" data-mp="2fjpu79l9efyq">
                    {formatPrice(total)}
                  </span>
                </div>

                <Link to="/checkout" className="mt-6 flex w-full items-center justify-center gap-2 bg-pink-500 py-4 text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors hover:bg-pink-600" data-id="element-842" data-mp="20vg4tvfn180t">
                  Proceder al pago
                  <ArrowRightIcon className="h-4 w-4" data-id="element-843" data-mp="25sfyt7z7qkbk" />
                </Link>
                <p className="mt-4 text-center text-[11px] text-white/35" data-id="element-844" data-mp="2jt0lwgc5v2av">
                  Pago seguro · Devoluciones dentro de 30 días
                </p>
              </div>
            </aside>
          </div>}
      </div>
    </div>;
}